import { useState, useEffect } from 'react';
import { featureFlagClient } from '@trello/feature-flag-client';

const flagEnabled = featureFlagClient.get('teamplates.web.left-nav-bar', false);

export const useWorkspaceNavigationEnabled = () => {
  const [
    isWorkspaceNavigationEnabled,
    setWorkspaceNavigationEnabled,
  ] = useState<boolean>(flagEnabled);

  useEffect(() => {
    const handleFlagChange = (newValue: boolean) => {
      if (isWorkspaceNavigationEnabled === true && newValue === false) {
        setWorkspaceNavigationEnabled(false);
        window.location.reload();
      }
    };

    featureFlagClient.on(
      'teamplates.web.left-nav-bar',
      false,
      handleFlagChange,
    );
    return () =>
      featureFlagClient.off('teamplates.web.left-nav-bar', handleFlagChange);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); //we only want this to fire on mount

  return isWorkspaceNavigationEnabled;
};
